import { Controller } from "@hotwired/stimulus";

// Shows a check box's nested region only while the box is ticked.
//
// Primer renders the nested form and sets its hidden state once, at render
// time, then leaves it alone. Without this the region stays on screen after the
// box is unticked.
export class NestedRevealController extends Controller {
  static targets = ["toggle", "region"];

  connect() {
    this.sync();
    this.toggleTarget.addEventListener("change", this.sync);
  }

  disconnect() {
    this.toggleTarget.removeEventListener("change", this.sync);
  }

  sync = () => {
    this.regionTarget.hidden = !this.toggleTarget.checked;
  };
}
